export default __webpack_public_path__ + "files/ce336cc65b66080406f10af19336453c.jpg";